export const METER_TYPE = {
  EXPERIENCE: 'EXPERIENCE',
  AVERAGE: 'AVERAGE',
};
